import type { Store } from 'redux';
import { fetchProformaSelectedForm } from '@atlassian/jira-proforma-request-type-config/src/services/fetch-proforma-form/index.tsx';
import { addProformaFormOptimistically } from '../../state/actions/index.tsx';
import { getProjectId, getCloudId, getProjectType } from '../../state/selectors.tsx';
import type { SelectedForm } from '../../state/types.tsx';

export const setSelectedForm = async (store: Store, formId: number) => {
	const state = store.getState();
	if (getProjectType(state) !== 'service_desk') {
		return;
	}

	const projectId = getProjectId(state);
	const cloudId = getCloudId(state);

	const selectedForm: SelectedForm | null = await fetchProformaSelectedForm({
		cloudId,
		projectId,
		formId,
	});

	selectedForm && store.dispatch(addProformaFormOptimistically(selectedForm));
};
